var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"guild-app"}},[(!_vm.account)?_c('login-view',{on:{"logged-in":_vm.handleLoggedIn}}):_c('guild-shell',{attrs:{"account":_vm.account},on:{"logout":_vm.handleLogout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }